import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    analytics: {},
    stages: [],
    strings: {},
    ageGroups: [],
    data: {},
    minPages: 6,
    pages: 6,
    links: {},
    questionLabel: '',
  },
  getters: {
    age: state => state.data['age'],
    ageGroup: state => state.ageGroups[state.data['age']],
    ageGroups: state => state.ageGroups,
    ageRange: state => state.data['age'] > -1 ? state.analytics.ageRanges[state.data['age']] : '',
    analytics: state => state.analytics,
    link: state => id => state.links[id],
    stage: state => id => state.data['stages'][id],
    string: state => id => state.strings[id],
    strings: state => state.strings,
    data: state => state.data,
    dataKey: state => key => state.data[key],
    pages: state => state.pages,
    progress: state => state.page / state.pages * 100,
    questionLabel: state => state.questionLabel,
  },
  mutations: {
    InitialiseData: (state, data) => state.data = data,
    SetAnalytics: (state, analytics) => state.analytics = analytics,
    SetLink: (state, data) => state.links[data.key] = data.value,
    SetData: (state, data) => state.data[data.key] = data.value,
    SetPages: (state, pages) => state.pages = state.minPages + pages,
    SetStrings: (state, strings) => state.strings = strings,
    SetStages: (state, stages) => state.stages = stages,
    SetAgeGroups: (state, ageGroups) => state.ageGroups = ageGroups,
    setQuestionLabel: (state, questionLabel) => state.questionLabel = questionLabel,
  },
})
